var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPayee = function SvgPayee(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59917 11.9999C4.44002 12.0001 4.28707 11.9374 4.17436 11.8251C4.06176 11.7125 3.9976 11.5595 3.9976 11.4003V5.56238C3.99793 5.23134 4.2671 4.96286 4.59819 4.96277C4.92919 4.96297 5.19747 5.23141 5.1978 5.56238V9.95496L10.9781 4.17468C11.2122 3.94089 11.5915 3.94118 11.8257 4.17468C12.06 4.409 12.06 4.789 11.8257 5.02331L6.05131 10.7987L10.4234 10.7889C10.7545 10.7884 11.023 11.0565 11.024 11.3876C11.0246 11.7189 10.7567 11.9885 10.4253 11.9891L4.59917 11.9999Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPayee);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "payee.f00c2dc75378defcd776e05f65cbf12d.svg";